import initCommon from './application.js'
import initSwiper from './initializers/Swiper.js'
import initWorkshopPreview from './initializers/WorkshopPreview.js'

const initStatic = () => {
  initCommon()
  initSwiper()
  initWorkshopPreview()
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initStatic)
} else {
  initStatic()
}
